import { type FC, type ReactNode } from 'react';

interface OptionsContainerProps {
  children: ReactNode;
  className?: string;
}

const OptionsContainer: FC<OptionsContainerProps> = ({ children, className = '' }) => (
  <div className={className}>
    <label className="pl4">Options</label>
    {children}
  </div>
);

export default OptionsContainer;
